module.exports = __webpack_public_path__ + "static/img/news65_11.30db75f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/Information/news65/news65_11.png
// module id = T0Dv
// module chunks = 0